import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconClose } from '@travel-frontend/icons';
import { forwardRef } from 'react';
import { Container } from '../../../primitives/Dialog/Head/components/Container.js';
import { IconButton } from '../../../primitives/IconButton/index.js';
export const Head = /*#__PURE__*/_styled(forwardRef(({
  children,
  raised = false,
  onClose,
  ...restProps
}, ref) => _jsxs(Container, {
  ...restProps,
  ref: ref,
  withContent: Boolean(children),
  raised: raised,
  children: [children, typeof onClose === 'function' && _jsx(IconButton, {
    round: true,
    variant: "info",
    category: "tertiary",
    onClick: onClose,
    "data-cy": "shared-dialogHead-closeButton",
    "data-testid": "shared-dialogHead-closeButton",
    children: _jsx(IconClose, {})
  })]
})), process.env.NODE_ENV === "production" ? {
  target: "e8rgw7y0"
} : {
  target: "e8rgw7y0",
  label: "Head"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhlYWQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTXFkIiwiZmlsZSI6IkhlYWQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCwganN4cyBhcyBfanN4cyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgSWNvbkNsb3NlIH0gZnJvbSAnQHRyYXZlbC1mcm9udGVuZC9pY29ucyc7XG5pbXBvcnQgeyBmb3J3YXJkUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgQ29udGFpbmVyIH0gZnJvbSAnLi4vLi4vLi4vcHJpbWl0aXZlcy9EaWFsb2cvSGVhZC9jb21wb25lbnRzL0NvbnRhaW5lci5qcyc7XG5pbXBvcnQgeyBJY29uQnV0dG9uIH0gZnJvbSAnLi4vLi4vLi4vcHJpbWl0aXZlcy9JY29uQnV0dG9uL2luZGV4LmpzJztcbmV4cG9ydCBjb25zdCBIZWFkID0gc3R5bGVkKGZvcndhcmRSZWYoKHsgY2hpbGRyZW4sIHJhaXNlZCA9IGZhbHNlLCBvbkNsb3NlLCAuLi5yZXN0UHJvcHMgfSwgcmVmKSA9PiAoX2pzeHMoQ29udGFpbmVyLCB7IC4uLnJlc3RQcm9wcywgcmVmOiByZWYsIHdpdGhDb250ZW50OiBCb29sZWFuKGNoaWxkcmVuKSwgcmFpc2VkOiByYWlzZWQsIGNoaWxkcmVuOiBbY2hpbGRyZW4sIHR5cGVvZiBvbkNsb3NlID09PSAnZnVuY3Rpb24nICYmIChfanN4KEljb25CdXR0b24sIHsgcm91bmQ6IHRydWUsIHZhcmlhbnQ6IFwiaW5mb1wiLCBjYXRlZ29yeTogXCJ0ZXJ0aWFyeVwiLCBvbkNsaWNrOiBvbkNsb3NlLCBcImRhdGEtY3lcIjogXCJzaGFyZWQtZGlhbG9nSGVhZC1jbG9zZUJ1dHRvblwiLCBcImRhdGEtdGVzdGlkXCI6IFwic2hhcmVkLWRpYWxvZ0hlYWQtY2xvc2VCdXR0b25cIiwgY2hpbGRyZW46IF9qc3goSWNvbkNsb3NlLCB7fSkgfSkpXSB9KSkpKSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUhlYWQuanMubWFwIl19 */");